export enum AllowedAdminUsernames {
    ANAS = 'anas',
    ADMIN = 'admin',
    ABDULKARIM = 'abdulkarim',
    A_ABAHUSAIN = 'a.abahusain@sequencive.com',
    A_ALHAMED = 'a.alhamed@sequencive.com',
    A_ALMANSOUR = 'a.almansour@sequencive.com',
    S_ALMADHI = 's.almadhi@sequencive.com',
    A_DAHY = 'a.dahy@sequencive.com',
    R_BUKHARI = 'r.bukhari@sequencive.com',
    A_HAGRAS = 'a.hagras@sequencive.com',
}

/** Exact email domains allowed for admin platform access (host only; no subdomain spoofing). */
export const ALLOWED_ADMIN_EMAIL_DOMAINS = ['sequencive.com', 'recyclee.io'] as const;

export enum ReadOnlyAdminUsernames {
    ANAS = 'anas@recyclee.io',
}

export enum UserRole {
    ADMIN = "admin",
    RECYCLER = "recycler",
    WASTE_OUTLET = "waste_outlet",
    TRUCK_CO = "truck_co",
    TRUCKER = "trucker",

    WASTE_OUTLET_ADMIN = "waste_outlet_admin",
    WASTE_OUTLET_OPS_MANAGER = "waste_outlet_ops_manager",
    WASTE_OUTLET_STAFF = "waste_outlet_staff",

    RECYCLER_ADMIN = "recycler_admin",
    RECYCLER_OPS_MANAGER = "recycler_ops_manager",
    RECYCLER_STAFF = "recycler_staff",

    TRUCK_CO_ADMIN = "truck_co_admin",
    TRUCK_CO_OPS_MANAGER = "truck_co_ops_manager",
    TRUCK_CO_STAFF = "truck_co_staff",

    
}

export interface LoginRequest {
    username?: string;
    phone?: string;
    password: string;
}

export type UserStatus = 'active' | 'inactive';

export interface UserAdminListParams {
    page?: number;
    limit?: number;
    status?: UserStatus;
    search?: string;
    organizationId?: string;
}

export interface UserAdminPagination {
    users: UserSchema[];
    total: number;
    page: number;
    limit: number;
}

export type PlatformPersonaSlug = "super_admin" | "platform_read_only" | "verifier";

export interface UserData {
    permissions?: string[] | Record<string, string[]>;
    permissions_legacy?: Record<string, string[]>;
    perm_ver?: number;
    sites?: Record<string, string[]> | null;
    role?: string;
    organization_id?: string;
    email?: string;
    full_name?: string;
    first_name?: string | null;
    last_name?: string | null;
    gender?: string | null;
    nationality?: string | null;
    date_of_birth?: string | null;
    iban?: string | null;
    // Driver fields (used in Drivers page, not in Admin Users form)
    driver_license_number?: string;
    vehicle_registration_number?: string;
    driver_license_expiry?: string | null;
    [key: string]: any;
}

export interface RegisterRequest {
    username?: string;
    password: string;
    password_confirm: string;
    phone?: string | null;
    platform_personas?: PlatformPersonaSlug[];
    data: UserData;
}

export interface RefreshTokenRequest {
    refresh_token: string;
}

export interface LoginResponse {
    access_token: string;
    refresh_token: string;
    token_type: string;
}

export interface UserSchema {
    id?: string;
    sub?: string;
    platform_personas?: PlatformPersonaSlug[];
    username: string;
    email?: string;
    full_name?: string;
    phone?: string | null;
    role?: string;
    organization_id?: string;
    organization_name?: string;
    is_active?: boolean;
    status?: string;
    created_at?: string;
    updated_at?: string;
    data?: UserData;
    exp?: number;
    iat?: number;
}

export interface UpdateUserRequest {
    username?: string | null;
    phone?: string | null;
    status?: string | null;
    data?: Partial<UserData> | null;
}

export interface ForgotPasswordRequest {
    username: string;
    platform: "OPS" | "ZERO" | "360" | "ADMIN" | "MARKET";
}

/** JWT access token payload — permissions at root after PR2 migration. */
export interface AuthTokenPayload {
    sub: string;
    username: string;
    typ: string;
    exp: number;
    iat: number;
    permissions: string[] | Record<string, string[]>;
    platform?: { personas: string[]; source?: string };
    platform_permissions?: string[];
    perm_ver?: number;
    requires_db_permissions?: boolean;
    sites?: Record<string, string[]>;
    is_pilot?: boolean;
}

export interface SetPasswordRequest {
    password: string;
    password_confirm: string;
}
